import styled, { css } from 'styled-components';

export const Separator = styled.div<{ verticalMargin?: string }>`
  ${({ theme: { border, color }, verticalMargin = '0' }) => css`
    width: 100%;
    border-bottom: ${border.width.thinner} ${border.style.solid} ${color.border.neutral.default};
    margin: ${verticalMargin} 0;
  `}
`;
